import { feedbackType } from "@/db/feedbackDataThree";
import Image from "next/image";

const FeedbackCard = ({ testimonial }: { testimonial: feedbackType }) => {
  return (

    <div >
          <div className="single-testimonial-item ">
      <Image
        width={160}
        height={30}
        src={testimonial.rating ? testimonial.rating : ""}
        alt="star"
      />
      <p className="justify-clean">{testimonial.feedback}</p>
      <div className="info d-flex mt-auto mb-auto align-items-center">
        <Image
          width={50}
          height={50}
          src={testimonial.image}
          className="rounded-circle"
          alt="user-image"
        />
        <div className="p-3">
          <h4 className="fw-medium fs-6">{testimonial.name}</h4>
          <span className="d-block fs-6 pb-9">{testimonial.designation}</span>
        </div>
      </div>
          </div>
    </div>
   
  );
};

export default FeedbackCard;
